import React, { Component } from 'react';
import PropTypes from 'prop-types';
import {
    MINIMUM_SARCASM_SCORE_INPUT_NAME,
    MAXIMUM_SARCASM_SCORE_INPUT_NAME,
    VALUES_OUT_OF_RANGE_ERROR,
    MAXIMUM_LESS_THAN_MINIMUM_ERROR,
    INVALID_RANGE_ERROR
} from './constants';

class SarcasmScoreRangeFilter extends Component {

    static propTypes = {
        minimumSarcasmScore: PropTypes.number.isRequired,
        maximumSarcasmScore: PropTypes.number.isRequired,
        setFeedModalSarcasmScoreFilter: PropTypes.func.isRequired,
        closeDropdownWindow: PropTypes.func
      }
    
    constructor(props) {
        super(props);
        this.state = {
            minimumSarcasmScore: '',
            maximumSarcasmScore: '',
            errorMessage: ''
        };
    }

    componentDidMount() {
        this.setState({
          minimumSarcasmScore: this.props.minimumSarcasmScore,
          maximumSarcasmScore: this.props.maximumSarcasmScore
        });
    }

    UNSAFE_componentWillReceiveProps(nextProps) {
        this.setState({
            minimumSarcasmScore: nextProps.minimumSarcasmScore,
            maximumSarcasmScore: nextProps.maximumSarcasmScore
          });
    }

    _setFormValues = event => {
        let { minimumSarcasmScore, maximumSarcasmScore } = this.state;
        if (event.target.name === MINIMUM_SARCASM_SCORE_INPUT_NAME && event.target.value !== minimumSarcasmScore) {
            if (event.target.value === ''){
                this.setState({
                    minimumSarcasmScore: ''
                });
            }
            else {
                this.setState({
                    minimumSarcasmScore: parseFloat(event.target.value)
                });
            }
        }
        if (event.target.name === MAXIMUM_SARCASM_SCORE_INPUT_NAME && event.target.value !== maximumSarcasmScore) {
            if (event.target.value === ''){
                this.setState({
                    maximumSarcasmScore: ''
                });
            }
            else {
                this.setState({
                    maximumSarcasmScore: parseFloat(event.target.value)
                });
            }
        }
    };

    _formSubmit = event => {
        event.preventDefault();
        if (this._validateFormInputs()){
            return false;
        }
        const { minimumSarcasmScore, maximumSarcasmScore } = this.state;
        this.props.setFeedModalSarcasmScoreFilter(minimumSarcasmScore, maximumSarcasmScore);
        this.props.closeDropdownWindow();
    };

    _validateFormInputs = () => {
        const { minimumSarcasmScore, maximumSarcasmScore } = this.state;
        let formError = false;
        if (minimumSarcasmScore === '' && maximumSarcasmScore === '') {
            formError = true;
            this.setState({
                errorMessage: INVALID_RANGE_ERROR
            });
        } 
        else if (minimumSarcasmScore < 0 || minimumSarcasmScore > 100) {
            formError = true;
            this.setState({
                errorMessage: VALUES_OUT_OF_RANGE_ERROR
            });
        }
        else if (maximumSarcasmScore < 0 || maximumSarcasmScore > 100) {
            formError = true;
            this.setState({
                errorMessage: VALUES_OUT_OF_RANGE_ERROR
            });
        }
        else if (maximumSarcasmScore && minimumSarcasmScore && maximumSarcasmScore < minimumSarcasmScore) {
            formError = true;
            this.setState({
                errorMessage: MAXIMUM_LESS_THAN_MINIMUM_ERROR
            });
        }
        else {
            this.setState({
                errorMessage: ''
            });
        }
        return formError;
    }

    render () {
        const {
            minimumSarcasmScore, 
            maximumSarcasmScore,
            errorMessage
        } = this.state;

        return (
            <form noValidate className="sarcasm-filter-form" onSubmit={e => this._formSubmit(e)}>
                <div className="input-scores-row">
                    <input
                        type="number"
                        placeholder="MIN"
                        name={MINIMUM_SARCASM_SCORE_INPUT_NAME}
                        value={minimumSarcasmScore}
                        onChange={e => this._setFormValues(e)}
                    />
                    <span>%</span>
                    <span>———</span>
                    <input
                        type="number"
                        placeholder="MAX"
                        name={MAXIMUM_SARCASM_SCORE_INPUT_NAME}
                        value={maximumSarcasmScore}
                        onChange={e => this._setFormValues(e)}
                    />
                    <span>%</span>
                    <button
                        type="submit"
                        className="btn"
                    >
                        APPLY
                    </button>
                </div>
                <hr className={`${errorMessage ? 'show-error-border' : ''}`}/>
                <div className="error-message">
                    {errorMessage}
                </div>
            </form>
        )
    }
}

export default SarcasmScoreRangeFilter;


// WEBPACK FOOTER //
// ./src/features/shared-components/SarcasmScoreRangeFilter/SarcasmScoreRangeFilter.js